import React from 'react'
import { Paper, Typography } from '@material-ui/core'
import { StopRounded } from '@material-ui/icons'
import { clustersNames } from '@auteco/constants'
import { useStyles } from './styles'


const CardInfoStatic = ({ item }) => {
    const classes = useStyles()
    const findName = ({ id }) => clustersNames.find(cluster => cluster.id === id).name
    return (
        <>
            <Paper
                className={classes.container}
                elevation={4}
            >
                <div className={classes.header}>
                    <StopRounded style={{ color: 'green' }} />
                    <Typography className={classes.title}>{item.titulo}</Typography>
                    <Typography className={classes.iconHeader}>OK</Typography>
                </div>
                <Typography className={classes.subtitle}><b>Descripción:</b>{item.texto}</Typography>
                <Typography className={classes.subtitle}><b>Tiempo estimado retorno de la inversión:</b> {item.finalizacion}</Typography>
                <Typography className={classes.subtitle}><b>Fecha de finalización:</b> {item.fecha_cierre}</Typography>
                <Typography className={classes.subtitle}><b>Beneficio estimado:</b> {item.valoracion}</Typography>
                <Typography className={classes.subtitle}><b>Beneficio final:</b> {item.valoracion_final}</Typography>
                <Typography className={classes.subtitle}><b>Inversión:</b>{item.costo}</Typography>
                <Typography className={classes.subtitle}><b>Cluster:</b> {findName({ id: item?.cluster_id })}</Typography>
            </Paper>
        </>
    )
}

export { CardInfoStatic }